import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const BENEFITS = [
  {
    title: "Delivers Deep Hydration",
    body:
      "Our triple-butter base and cold-pressed carrier oils deliver moisture that outlasts a full day — kicking dryness, ash, and flakes to the curb."
  },
  {
    title: "Boosts Skin Radiance",
    body:
      "Vitamin E + rosehip seed oil visibly improve skin luminosity. Your natural glow, amplified — not covered up."
  },
  {
    title: "Evens Skin Tone",
    body:
      "Consistent daily use helps blur uneven texture, dark spots, and dry patches so your finish reads smooth and uniform."
  },
  {
    title: "Fast-Absorbing, Never Greasy",
    body:
      "Whipped cold, twice — the mousse texture melts on contact and disappears in seconds. Dress right after. No residue."
  },
  {
    title: "100% Pure, Naturally Sourced",
    body:
      "Raw unrefined shea butter, organic rosehip, organic castor, and organic vitamin E oil. No fillers, no water, no synthetic thickeners."
  }
];

const BenefitsAccordion = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="py-24 md:py-32 border-t border-off-white/10 bg-charcoal">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 max-w-3xl mx-auto">
          <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-3">// WHY IT WORKS</p>
          <h2 className="font-serif-display italic text-5xl md:text-7xl leading-[0.95] text-off-white">
            How Whip It Up<br />transforms your skin.
          </h2>
        </div>

        <div className="grid md:grid-cols-12 gap-10 items-center">
          {/* Editorial image */}
          <div className="md:col-span-5 relative aspect-[4/5] overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1693004925174-d9e06209d0ee?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
              alt="Ritual"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/60 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="font-mono text-[10px] tracking-[0.3em] text-rose">// APPLIED DAILY</p>
              <p className="font-serif-display italic text-xl md:text-2xl text-off-white mt-2">
                Softer skin within a week. Guaranteed.
              </p>
            </div>
          </div>

          {/* Accordion */}
          <div className="md:col-span-7">
            <ul className="divide-y divide-off-white/10 border-y border-off-white/10">
              {BENEFITS.map((b, i) => {
                const isOpen = openIdx === i;
                return (
                  <li key={b.title}>
                    <button
                      onClick={() => setOpenIdx(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between text-left py-6 group"
                    >
                      <div className="flex items-baseline gap-5">
                        <span className="font-mono text-[11px] tracking-[0.25em] text-rose">
                          0{i + 1}
                        </span>
                        <span className="font-serif-display italic text-2xl md:text-3xl text-off-white leading-tight group-hover:text-rose transition-colors-only">
                          {b.title}
                        </span>
                      </div>
                      <span className="shrink-0 w-9 h-9 border border-off-white/25 group-hover:border-rose flex items-center justify-center transition-colors-only">
                        {isOpen ? (
                          <Minus size={14} className="text-rose" />
                        ) : (
                          <Plus size={14} className="text-off-white/80" />
                        )}
                      </span>
                    </button>
                    <div
                      className="grid transition-all duration-500 ease-in-out"
                      style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                    >
                      <div className="overflow-hidden">
                        <p className="text-off-white/70 font-light text-[15px] leading-relaxed pb-6 pl-11 max-w-2xl">
                          {b.body}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsAccordion;
